import * as React from 'react';
import { SVGProps } from 'react';

const IconAlertSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-17.143c.789 0 1.429.64 1.429 1.429v7.143a1.429 1.429 0 0 1-2.858 0V6.286c0-.79.64-1.429 1.429-1.429zm0 14.286c.868 0 1.572-.64 1.572-1.429s-.704-1.428-1.572-1.428c-.868 0-1.571.64-1.571 1.428 0 .79.703 1.429 1.571 1.429z"
    />
  </svg>
);
export default IconAlertSizeM;
